"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// https://www.w3.org/wiki/PF/XTech/HTML5/RoleAttribute
// ARIA 1.0 Pre-Defined Roles
exports.Roles = {
    Alert: "alert",
    Alertdialog: "alertdialog",
    Application: "application",
    Button: "button",
    Checkbox: "checkbox",
    Columnheader: "columnheader",
    Combobox: "combobox",
    Description: "description",
    Dialog: "dialog",
    Directory: "directory",
    Document: "document",
    Grid: "grid",
    Gridcell: "gridcell",
    Group: "group",
    Heading: "heading",
    Img: "img",
    Link: "link",
    List: "list",
    Listbox: "listbox",
    Listitem: "listitem",
    Log: "log",
    Marquee: "marquee",
    Menu: "menu",
    Menubar: "menubar",
    Menuitem: "menuitem",
    Menuitemcheckbox: "menuitemcheckbox",
    Menuitemradio: "menuitemradio",
    Option: "option",
    Presentation: "presentation",
    Progressbar: "progressbar",
    Radio: "radio",
    Radiogroup: "radiogroup",
    Region: "region",
    Row: "row",
    Rowheader: "rowheader",
    Separator: "separator",
    Slider: "slider",
    Spinbutton: "spinbutton",
    Status: "status",
    Tab: "tab",
    Tablist: "tablist",
    Tabpanel: "tabpanel",
    Textbox: "textbox",
    Timer: "timer",
    Toolbar: "toolbar",
    Tooltip: "tooltip",
    Tree: "tree",
    Treegrid: "treegrid",
    Treeitem: "treeitem"
};
//# sourceMappingURL=Aria.js.map